/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Action_SubmitInputs */

const vi_pdc_action_submit = /** @type {(inputs: Pdc_Action_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu phiếu`)
};

/**

* @param {Pdc_Action_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_action_submit = /** @type {((inputs?: Pdc_Action_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Action_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_action_submit(inputs)
});